<script setup lang="ts">
import {storeToRefs} from 'pinia'
import {useToastStore} from '../stores/toast'
import RBButton from '../components/Button.vue'
import {useNewUiEnabled} from '@/composable/useNewUiEnabled'

declare global {
  var HubSpotConversations: {
    widget: {
      open: () => void
    }
  }
}

const toastStore = useToastStore()
const {currentToast} = storeToRefs(toastStore)
const isNewUiEnabled = useNewUiEnabled()

function report() {
  window.HubSpotConversations.widget.open()
}
</script>

<template>
  <div
    class="fixed w-[75%] left-[50%] translate-x-[-50%] overflow-y-hidden z-toast"
    :class="{'bottom-0 ': !isNewUiEnabled, 'bottom-5 pb-3 drop-shadow-new-dark': isNewUiEnabled}"
  >
    <transition
      enter-active-class="duration-500 ease-in-out"
      enter-from-class="translate-y-full scale-y-25 opacity-0"
      enter-to-class="translate-y-0 scale-y-100 opacity-100"
      leave-active-class="duration-500 ease-in-out"
      leave-from-class="translate-y-0 scale-y-100 opacity-100"
      leave-to-class="translate-y-full scale-y-25 opacity-0"
    >
      <div
        v-if="!!currentToast"
        class="relative max-w-[1024px] max-h-fit mx-auto"
        :class="{
          'border-t-[10px] bg-branddark rounded-[4px] text-white mb-6 p-6 shadow-md': !isNewUiEnabled,
          'border-t-[6px] bg-white rounded-new-xl text-new-neutral-700 px-new-4xl py-new-3xl shadow-[1px_1px_4px_1px_rgba(0,0,0,0.25)]':
            isNewUiEnabled,
          'border-olive': !isNewUiEnabled && !currentToast?.isError,
          'border-red': !isNewUiEnabled && currentToast?.isError,
          'border-new-green-500': isNewUiEnabled && !currentToast?.isError,
          'border-new-red-500': isNewUiEnabled && currentToast?.isError,
        }"
      >
        <RBButton
          v-if="currentToast.isError && !isNewUiEnabled"
          class="absolute right-0 top-0 mr-6 mt-6"
          variant="warning-text"
          @click="report"
        >
          <i class="fa-solid fa-location-arrow"></i> {{ $t('report') }}
        </RBButton>
        <div v-if="isNewUiEnabled" class="mb-4 flex items-center gap-4">
          <h1 class="min-w-0 flex-1 text-new-xl font-light">{{ currentToast.title }}</h1>
          <button
            class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-new-neutral-700 transition-colors -mr-new-sm hover:bg-new-neutral-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-new-primary-500"
            type="button"
            @click="toastStore.clearToast()"
          >
            <i class="fa-solid fa-xmark text-[1.25rem]"></i>
          </button>
        </div>
        <h1 v-else class="text-white">{{ currentToast.title }}</h1>
        <p
          v-for="message in currentToast.messages"
          :key="message"
          :class="{'text-new-base': isNewUiEnabled, 'text-white': !isNewUiEnabled}"
        >
          {{ message }}
        </p>
      </div>
    </transition>
  </div>
</template>
